<form [formGroup]="form">
    <div class="flex column" formArrayName="invitations">
        @for (invitationForm of invitations.controls; track invitationForm; let i = $index) {
            <div class="flex row" [formGroup]="invitationForm">
                <mat-form-field appearance="fill" class="flex-70">
                    <mat-label>Email</mat-label>
                    <input
                        matInput
                        type="email"
                        placeholder="Ex. foo@gmail.com"
                        formControlName="email"
                    />
                </mat-form-field>
                <mat-form-field appearance="fill" class="flex-30">
                    <mat-label>Role</mat-label>
                    <mat-select formControlName="role">
                        <mat-select-trigger>
                            {{ roles[invitationForm.value.role].name }}
                        </mat-select-trigger>
                        @for (role of roles; track role) {
                            <mat-option [value]="role.id">
                                <b>{{ role.name }}</b
                                ><br />
                                <small>{{ role.description }}</small>
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <button
                    mat-icon-button
                    (click)="removeRow(i)"
                    [disabled]="invitations.length === 1"
                >
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
        }
    </div>
</form>
<div class="flex row align-space-between justify-center">
    <div class="flex">
        <button mat-button (click)="addInviteRow()">
            <mat-icon>add</mat-icon>
            Add Another
        </button>
        <button mat-button (click)="addMultiple()"><mat-icon>add</mat-icon> Add Multiple</button>
    </div>

    @if (withLink) {
        <div class="flex-30"><frog-invitation-link></frog-invitation-link> instead</div>
    }
</div>
